import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  StopOutlined,
} from '@ant-design/icons'
import { Tag } from 'antd'

import { MerchantStatus } from '../../types/merchant'

interface Props {
  status?: MerchantStatus
  isExpired?: boolean
}

// ร้านปิดใช้งานกับหมดอายุเกิดพร้อมกันได้ — โชว์ทั้งคู่ ไม่เลือกอันเดียว
const MerchantStatusTags = ({ status, isExpired }: Props) => {
  const isInactive = status === MerchantStatus.INACTIVE

  if (!isInactive && !isExpired) {
    return (
      <Tag color="success" icon={<CheckCircleOutlined />}>
        ใช้งานอยู่
      </Tag>
    )
  }

  return (
    <>
      {isExpired && (
        <Tag color="error" icon={<ClockCircleOutlined />}>
          หมดอายุ
        </Tag>
      )}
      {isInactive && (
        <Tag color="default" icon={<StopOutlined />}>
          ปิดใช้งาน
        </Tag>
      )}
    </>
  )
}

export default MerchantStatusTags
